import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/api';

import Modal from "./Modal"

import ParadigmaTable from "../../../components/ParadigmaTable/ParadigmaTable"

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

class Cuentas extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Código",
                    id: "codigo",
                    accessor: d => d.codigo,
                    show: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
                {
                    Header: "Leyenda",
                    id: "leyenda",
                    accessor: d => d.leyenda,
                    show: true,
                },
                {
                    Header: "Tipo por Defecto",
                    id: "nombre_tipoDefecto",
                    accessor: 'nombre_tipoDefecto',
                    show: true,
                    exportWidth: "100",
                    Filter: ({ filter, onChange }) =>
                        <ParadigmaAsyncSeeker
                                clearable
                                url={undefined}
                                optionDefault={[{nombre: 'Ingreso', id: 'Ingreso'}, {nombre: 'Egreso', id: 'Egreso'}]}
                                value={(filter && filter.value) ? filter.value.input : ""}
                                onChange={data => (data) ? (onChange({lookup: null, input: data.id})): ((filter) ? onChange('') : null)}
                            />
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        component: (props) => <Modal {...props} action="CREATE" />,
                        permission: 'caja_cuentas_new',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="EDIT" />,
                        permission: 'caja_cuentas_edit',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DETAIL" />,
                        permission: 'caja_cuentas_detail',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DELETE" />,
                        permission: 'caja_cuentas_delete',
                    }
                ]}
                apiUrl={api.caja.cuentas}
                columns={this.state.columns}
                exportUrl={api.caja.cuentas}
                title={"Cuentas"}
            />
        );
    }
}

export default Cuentas;



// WEBPACK FOOTER //
// ./src/views/Caja/Cuentas/Cuentas.js